module.exports = __webpack_public_path__ + "img/antes_despues_121.de74c140.png";